import logo from './logo.svg';
import React, { useEffect, useState } from "react"
import './App.css';


export default App;

function App() {
  const [resultState, setResultState] = useState({
    // cvss results
    cvss: 'N/A',
    cvssrating: '',
    cvsscolor: 'alert alert-default', 
    cvssvector: 'N/A'
  })

  const [state, setState] = useState({
    // Base
    AV:null,
    AC:null,
    PR:null,
    UI:null,
    S:null,
    C:null,
    I:null,
    A:null, 
    // Temporal
    E: null, 
    RL: null, 
    RC: null, 
    // Environmental
    CR: null, 
    IR: null, 
    AR: null, 
    MAV: null, 
    MAC: null, 
    MPR: null, 
    MUI: null, 
    MS: null, 
    MC: null, 
    MI: null, 
    MA: null
    });

    useEffect( () => 
    {
      update();
    }, [state])


    function updateBase(){
      var cnum = -1;
      switch(state.C)
      {
        case 'H': cnum = 0.56; break; 
        case 'L': cnum = 0.22; break; 
        case 'N': cnum = 0.0; break; 
        default: cnum = -1; break; 
      }
      var inum = -1;
      switch(state.I)
      {
        case 'H': inum = 0.56; break; 
        case 'L': inum = 0.22; break; 
        case 'N': inum = 0.0; break; 
        default: inum = -1; break; 
      }
      var anum = -1;
      switch(state.A)
      {
        case 'H': anum = 0.56; break; 
        case 'L': anum = 0.22; break; 
        case 'N': anum = 0.0; break; 
        default: anum = -1; break; 
      }
      var avnum = -1;
      switch(state.AV)
      {
        case 'N': avnum = 0.85; break; 
        case 'A': avnum = 0.62; break; 
        case 'L': avnum = 0.55; break; 
        case 'P': avnum = 0.2; break; 
        default: avnum = -1; break; 
      }
      var acnum = -1;
      switch(state.AC)
      {
        case 'L': acnum = 0.77; break; 
        case 'H': acnum = 0.44; break; 
        default: acnum = -1; break; 
      }      
      var prnum = -1; 
      switch(state.PR)
      {
        case 'N': prnum  = 0.85; break; 
        case 'L': prnum = 0.62; if(state.S === 'C') prnum = 0.68; break; 
        case 'H': prnum = 0.27; if(state.S === 'C') prnum = 0.5; break; 
        default: prnum = -1; break; 
      }        
      var uinum = -1; 
      switch(state.UI)
      {
        case 'N': uinum  = 0.85; break; 
        case 'R': uinum = 0.62; break; 
        default: uinum = -1; break; 
      }      
      var snum = -1; 
      switch(state.S)
      {
        case 'C': snum  = 0; break; 
        case 'U': snum = 0; break; 
        default: snum = -1; break; 
      }      

      if(cnum === -1 || inum === -1 || anum === -1 || avnum === -1 || acnum === -1 || prnum === -1 || uinum === -1 || snum === -1 )
      {
        /*
        console.log('avnum:' + avnum);
        console.log('acnum:' + acnum);
        console.log('prnum:' + prnum);
        console.log('uinum:' + uinum);
        console.log('snum:' + snum);
        console.log('cnum:' + cnum);
        console.log('inum:' + inum);
        console.log('anum:' + anum);
        console.log('incomplete !!!!!!!!!!!');*/
        state.cvss = 'N/A';      
        state.cvssvector = 'N/A';      
        return; 
      }
      else
      {
        //console.log("completed!!");
        var iss = (1-((1-cnum)*(1-inum)*(1-anum)));
        var impact = -1; 

        console.log('iss = ', iss);
        //var sc = 0.0;
        var ex = 0.0;
        if(state.S === 'U')
        {
          impact = 6.42 * iss;  
        }
        else{
          impact = 7.52 * (iss-0.029)-3.25 *Math.pow(iss-0.02, 15);
        }
        ex = 8.22 * avnum * acnum * prnum * uinum; 

        var cvss = -1.0;
        var vect = '';
        var rating = '(None)';
        var ratingclass = 'alert alert';
        if(iss <= 0)
        {
          cvss = 0.0;                     
          ratingclass += '-success';
        }
        else if(state.S === 'U')
        {
          cvss = myRoundup(Math.min(impact+ex, 10)).toFixed(1);
          vect = 'CVSS:3.1/AV:'+state.AV+'/AC:'+state.AC+'/PR:'+state.PR+'/UI:'+state.UI+'/S:'+state.S+'/C:'+state.C+'/I:'+state.I+'/A:'+state.A;
        }
        else
        {
          cvss = myRoundup(Math.min(1.08*(impact+ex), 10)).toFixed(1);
          vect = 'CVSS:3.1/AV:'+state.AV+'/AC:'+state.AC+'/PR:'+state.PR+'/UI:'+state.UI+'/S:'+state.S+'/C:'+state.C+'/I:'+state.I+'/A:'+state.A;
        }
        if(cvss > 8.99){
          rating='(Critical)';
          ratingclass += '-primary';
        }
        else if(cvss > 6.99){
          rating='(High)';
          ratingclass += '-danger';
        }
        else if(cvss > 3.99){
          rating='(Medium)';
          ratingclass += '-alertwarning';
        }
        else if(cvss > 0.09){
          rating='(Low)';
          ratingclass += '-warning';
        }

        setResultState({...resultState, cvss: cvss, cvssvector : vect, cvssrating: rating, cvsscolor: ratingclass});
      }
       
    }

    function myRoundup(a)
    {
      var input = Math.round(a*100000); 
      if((input % 10000) === 0) {
        return input/100000.0;
      }
      else {
        return (Math.floor(input/10000)+1)/10.0;
      }
    }

    function updateTemporal(){
        
    }

    function updateEnvironmental(){
            
    }

    function update(){
        updateBase();
        updateTemporal();
        updateEnvironmental();
    }

  return (
    <div>
    <div className="row">
      <div className='col-12'>
      <div className={resultState.cvsscolor}>
			  <strong className='text-4'>CVSS Score: {resultState.cvss} {resultState.cvssrating}</strong>
        <br></br>
			  <div className='text-1'><b>Vector:</b> {resultState.cvssvector}</div>
			</div>
      </div>
    </div>

    <div className="row">
    <div className="col-6">
    <h5 className='mb-0'>Attack Vector (AV)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, AV: 'N'});}} type="radio" id="radio1av" name="av" />
        <label for="radio1av" data-multiline="true" data-tip="The vulnerable component is exploitable over the network.">Network (N)</label>
        <input onClick={()=>{setState({...state, AV: 'A'});}} type="radio" id="radio2av" name="av" />
        <label for="radio2av" data-multiline="true" data-tip="The vulnerable component is bound to the network stack, <br/>but the attack is limited at the protocol level to a logically adjacent topology. ">Adjacent (A)</label>
        <input onClick={()=>{setState({...state, AV: 'L'});}} type="radio" id="radio3av" name="av" />
        <label for="radio3av" data-multiline="true" data-tip="The vulnerable component can be exploited<br/>with access to the local machine/OS.">Local (L)</label>
        <input onClick={()=>{setState({...state, AV: 'P'});}} type="radio" id="radio4av" name="av" />
        <label for="radio4av" data-multiline="true" data-tip="The vulnerable component can be exploited<br/>with physical interaction/access.">Physical (P)</label>
    </div>
    <h5 className='mb-0 mt-3'>Attack Complexity (AC)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, AC: 'L'});}} type="radio" id="radio1ac" name="ac" />
        <label for="radio1ac">Low (L)</label>
        <input onClick={()=>{setState({...state, AC: 'H'});}} type="radio" id="radio2ac" name="ac" />
        <label for="radio2ac">High (H)</label>
    </div>
    <h5 className='mb-0 mt-3'>Privileges Required (PR)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, PR: 'N'});}} type="radio" id="radio1pr" name="pr" />
        <label for="radio1pr">None (N)</label>
        <input onClick={()=>{setState({...state, PR: 'L'});}} type="radio" id="radio2pr" name="pr" />
        <label for="radio2pr">Low (L)</label>
        <input onClick={()=>{setState({...state, PR: 'H'});}} type="radio" id="radio3pr" name="pr" />
        <label for="radio3pr">High (H)</label>
    </div>
    <h5 className='mb-0 mt-3'>User Interaction (UI)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, UI: 'N'});}} type="radio" id="radio1ui" name="ui" />
        <label for="radio1ui">None (N)</label>
        <input onClick={()=>{setState({...state, UI: 'R'});}} type="radio" id="radio2ui" name="ui" />
        <label for="radio2ui">Required (R)</label>
    </div>
    </div>
    <div className="col-6">
    
    <h5 className='mb-0'>Scope (S)</h5>
    <div className="toggle-btn2">
    <input onClick={()=>{setState({...state, S: 'U'});}} type="radio" id="radio2s" name="s" />
        <label for="radio2s">Unchanged (U)</label>
        <input onClick={()=>{setState({...state, S: 'C'});}} type="radio" id="radio1s" name="s" />
        <label for="radio1s">Changed (C)</label>
    </div>
    <h5 className='mb-0 mt-3'>Confidentiality (C)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, C: 'N'});}} type="radio" id="radio1c" name="c" />
        <label for="radio1c">None (N)</label>
        <input onClick={()=>{setState({...state, C: 'L'});}} type="radio" id="radio2c" name="c" />
        <label for="radio2c">Low (L)</label>
        <input onClick={()=>{setState({...state, C: 'H'});}} type="radio" id="radio3c" name="c" />
        <label for="radio3c">High (H)</label>
    </div>
    <h5 className='mb-0 mt-3'>Integrity (I)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, I: 'N'});}} type="radio" id="radio1i" name="i" />
        <label for="radio1i">None (N)</label>
        <input onClick={()=>{setState({...state, I: 'L'});}} type="radio" id="radio2i" name="i" />
        <label for="radio2i">Low (L)</label>
        <input onClick={()=>{setState({...state, I: 'H'});}} type="radio" id="radio3i" name="i" />
        <label for="radio3i">High (H)</label>
    </div>
    <h5 className='mb-0 mt-3'>Availability (A)</h5>
    <div className="toggle-btn2">
        <input onClick={()=>{setState({...state, A: 'N'});}} type="radio" id="radio1a" name="a" />
        <label for="radio1a">None (N)</label>
        <input onClick={()=>{setState({...state, A: 'L'});}} type="radio" id="radio2a" name="a" />
        <label for="radio2a">Low (L)</label>
        <input onClick={()=>{setState({...state, A: 'H'});}} type="radio" id="radio3a" name="a" />
        <label for="radio3a">High (H)</label>
    </div>    
    
    </div>
    </div>

    </div>
  );
}





// WEBPACK FOOTER //
// ./src/App.js